module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/ReserveActivationPopover/images/active-background.a89c869d.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/ReserveActivationPopover/images/active-background.png
// module id = 3407
// module chunks = 11